export default __webpack_public_path__ + "static/media/copy-svgrepo-com.fc19c4f9.svg";